module.exports = __webpack_public_path__ + "static/media/08.2cf1cdb6.webp";